


































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Test as ITest } from "@/api/models/test";
import { TestQuestion as ITestQuestion } from "@/api/models";
import TestQuestionsList, {
  TestQuestionsListParams
} from "@/getinfo-api/test-questions";
import api from "@/getinfo-api";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import TestQuestionsListItem from "@/components/tests/TestQuestionsListItem.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { TestAnswer as ITestAnswer } from "@/api/models/test-answer";
import { isEqual } from "lodash";
import moment from "moment";
import TextField from "@/components/form/CustomPage/textField.vue";

@Component({
  components: {
    TextField,
    CustomTableCol,
    CustomTableItem,
    TestQuestionsListItem,
    CustomTable,
    CustomButton,
    CBlock
  }
})
export default class TestTraining extends Vue {
  test!: ITest;
  testQuestionsList!: Array<ITestQuestion>;
  questionCount: number = 1;
  perPage: number = 3;
  successCount: number = 0;
  answeredQuestions: Array<any> = [];
  currentAnswer: Array<any> = [];
  currentTimer!: string;
  isAnswersOpen: boolean = false;
  isShowComment: boolean = false;
  isFinished: boolean = false;
  isShowDescription: boolean = true;
  course!: any;
  offset: number = 0;
  loadingCount: number = 0;
  isLoading: boolean = false;
  lecture!: any;
  testCount: number = 0;

  data() {
    return {
      currentTimer: undefined,
      test: undefined,
      testQuestionsList: undefined,
      course: undefined,
      lecture: undefined
    };
  }

  get isFinishedAuto() {
    if (this.testQuestionsList) {
      return this.answeredQuestions.length === this.testQuestionsList.length;
    } else {
      return false;
    }
  }

  @Watch("answeredQuestions")
  check() {
    if (this.answeredQuestions.length === this.test.questionsCount) {
      this.finishTest();
    }
  }

  get checkDisable() {
    return this.answeredQuestions.some(
      el => el.questionNumber === this.questionCount
    );
  }

  async getTest() {
    try {
      let { data } = await api.TestApi.get(this.$route.params.id);
      this.test = data;
      this.successCount = this.test.questionsCountToCompletion;
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    }
  }

  async getQuestions() {
    this.isLoading = true;
    try {
      let params: TestQuestionsListParams = {
        offset: this.offset,
        limit:
          this.test.questionsCount > 100
            ? this.test.questionsCount - this.testQuestionsList.length < 100
              ? this.test.questionsCount - this.testQuestionsList.length
              : 100
            : this.test.questionsCount,
        id: this.$route.params.id,
        randomize: this.test?.randomize
      };
      let { data } = await TestQuestionsList(params);
      this.testQuestionsList = [...this.testQuestionsList, ...data.questions];

      if (this.test.showAllQuestions) {
        this.testQuestionsList = [];
        this.test.questionsCount = data.count;
        this.offset = 0;
        this.test.showAllQuestions = false;
        await this.getQuestions();
      }
      if (this.testQuestionsList.length !== this.test.questionsCount) {
        this.offset += 100;
        this.loadingCount = this.testQuestionsList.length;
        await this.getQuestions();
      }
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  get currentQuestions() {
    if (this.testQuestionsList.length) {
      return this.testQuestionsList[this.questionCount - 1]?.answers?.map(
        (el: any) => {
          return {
            text: el.body,
            value: el
          };
        }
      );
    } else {
      return [
        {
          text: "",
          value: ""
        }
      ];
    }
  }

  get amountRightQuestions() {
    let res = 0;

    this.answeredQuestions?.forEach((el: any) => {
      this.isRightQuestion(el) ? res++ : res;
    });

    return res;
  }

  get result() {
    return this.amountRightQuestions < this.successCount
      ? this.$tc(this.$translate.Unsuccessful)
      : this.$tc(this.$translate.Successful);
  }

  isRightQuestion(question: any) {
    let userAnswers = question.answer.map((el: any) => el.id).sort();
    let rightAnswers = question.question?.answers
      ?.filter((el: any) => el.value)
      ?.map((el: any) => el.id)
      .sort();
    return isEqual(userAnswers, rightAnswers);
  }

  clearCurrentAnswer() {
    this.currentAnswer = [];
  }

  saveQuestion() {
    if (this.currentAnswer.length > 0) {
      const isHasComment = this.currentQuestions?.some(el => el.value?.comment);

      if (isHasComment && this.test.testAnswerComment) {
        this.isShowComment = true;
      } else {
        this.submitQuestion();
      }
    } else {
      this.$store.dispatch(
        "localError",
        this.$tc(this.$translate.AtLeastOneAnswerMustBeCorrect)
      );
    }
  }

  getComment(answer: ITestAnswer) {
    return answer?.comment ? answer.comment : "";
  }

  get questionsCountToCompletion() {
    return this.test.questionsCountToCompletion
      ? this.test.questionsCountToCompletion
      : this.$tc(this.$translate.NotLimited);
  }

  submitQuestion() {
    if (this.currentAnswer.length > 0) {
      this.isShowComment = false;
      this.answeredQuestions.unshift({
        questionNumber: this.questionCount,
        question: this.testQuestionsList[this.questionCount - 1],
        answer: this.currentAnswer
      });
      this.currentAnswer = [];
      let nextIsDone = (number: any): number => {
        if (this.checkDone(number)) {
          return nextIsDone(number + 1);
        } else {
          if (this.isFinishedAuto) {
            this.isAnswersOpen = true;
            //@ts-ignore
            return true;
          }
          return number > this.testQuestionsList.length
            ? nextIsDone(1)
            : number;
        }
      };
      if (this.questionCount === this.testQuestionsList.length) {
        this.questionCount = nextIsDone(0);
      }
      this.questionCount = nextIsDone(this.questionCount + 1);
    } else {
      this.$store.dispatch(
        "localError",
        this.$tc(this.$translate.YouMustSelectAtLeastOneOption)
      );
    }
  }

  checkDone(page: number) {
    if (this.answeredQuestions.map(el => el.questionNumber).includes(page)) {
      return true;
    } else {
      return false;
    }
  }

  checkIsUserAnswer(answerId: string, userAnswers: any) {
    let userAnswersIds = userAnswers.map((el: any) => el.id);
    let res = false;
    userAnswersIds.forEach((el: string) => {
      if (answerId === el) {
        res = true;
      }
    });
    return res;
  }

  @Watch("questionCount")
  checkQuestionCount() {
    if (this.checkDone(this.questionCount)) {
      this.currentAnswer = this.answeredQuestions.find(
        (el: any) => el.questionNumber === this.questionCount
      ).answer;
    }
  }

  timeLimit() {
    if (this.test.timeLimit !== 0) {
      let limitInMin = this.test.timeLimit * 60 * 1000;

      let duration: any = moment.duration(limitInMin, "milliseconds");
      let interval = 1000;

      let setIntervalId = setInterval(() => {
        duration = moment.duration(duration - interval, "milliseconds");
        this.currentTimer =
          duration.hours() +
          ":" +
          duration.minutes() +
          ":" +
          duration.seconds();
        this.currentTimer = moment
          .utc(duration.as("milliseconds"))
          .format("HH:mm:ss");

        if (duration._milliseconds <= 0) {
          clearInterval(setIntervalId);
          this.currentTimer = this.$tc(this.$translate.TimeExpired);
          this.finishTest();
        }
        if (this.isFinished) {
          clearInterval(setIntervalId);
        }
      }, interval);
    } else {
      this.currentTimer = this.$tc(this.$translate.NotLimited);
    }
  }

  finishTest() {
    this.isFinished = true;
    this.isShowDescription = false;
    if (localStorage.getItem("testFinished")) {
      localStorage.removeItem("testFinished");
    }
  }

  async init() {
    this.testQuestionsList = [];
    this.questionCount = 1;
    this.perPage = 3;
    this.successCount = 0;
    this.answeredQuestions = [];
    this.currentAnswer = [];
    this.isAnswersOpen = false;
    this.isShowComment = false;
    this.isFinished = false;
    this.currentTimer = "";
    await this.getTest();
    await this.getQuestions();
    if (!this.test.considerTime) {
      this.timeLimit();
    }
  }

  getCourse() {
    if (this.$route.params.courseId) {
      api.CourseApi.get(this.$route.params.courseId).then(res => {
        this.course = res.data;
      });
    }
  }

  getLecture() {
    if (this.$route.params.lectureId) {
      api.CourseLectureApi.get(
        this.$route.params.courseId,
        this.$route.params.lectureId
      ).then(res => {
        this.lecture = res.data;
      });
    }
  }

  created() {
    this.getCourse();
    this.getLecture();
    this.init();
  }
}
